export {default as Home} from "../page/HomePage"
export {default as CourseDetailPage} from "../page/CourseDetailPage"
export {default as ResonanceIndore} from "../page/WhyResonanceInd"
export {default as WhyResonance} from "../page/WhyResonancePage"
export {default as ResoSat} from "../page/ResoSatPage"
export {default as Result} from "../page/ResultPage"

